import styled from '@emotion/styled';
import * as React from 'react';

interface IStyledSpanProps {
	size: string;
}

const StyledSpan = styled.span<IStyledSpanProps>`
	font-size: ${(props) => props.size};
`;

interface IEmojiProps {
	symbol: string;
	label?: string;
	fontSize?: string;
}

export const Emoji: React.FC<IEmojiProps> = ({ symbol, label, fontSize }) => {
	const size = fontSize ? fontSize : '18px';
	return (
		<StyledSpan
			className="emoji"
			role="img"
			aria-label={label ? label : ''}
			aria-hidden={label ? false : true}
			size={size}
			>
			{symbol}
		</StyledSpan>);
};
